import { FC, ReactNode } from 'react';

import classnames from 'classnames/bind';
import styles from './FieldContainer.module.scss';
const cx = classnames.bind(styles);

interface FieldContainerProps {
  className?: string;
  required?: boolean;
  // TODO: label로 프로퍼티명 수정 필요
  name?: ReactNode | string;
  smallName?: boolean;
  premiumName?: boolean;
  border?: boolean;
  prev?: ReactNode;
  children: ReactNode;
}

const FieldContainer: FC<FieldContainerProps> = ({
  className,
  required = false,
  name,
  smallName,
  premiumName,
  border = false,
  prev,
  children,
}) => {
  return (
    <div className={cx('detailInfoWrap', { typeBorder: border }, className)}>
      {prev}
      <div className={cx('infoTitleArea')}>
        {name && (
          <strong
            className={cx('infoTitle', { typeText: smallName }, { typePremium: premiumName }, { require: required })}
          >
            {name}
          </strong>
        )}
      </div>
      <div className={cx('infoDataArea')}>{children}</div>
    </div>
  );
};

export default FieldContainer;
